<template>
    <span class="pill" :class="{ 'pill--default': color.toLowerCase() === '#d3d7cf' }" :style="'border-color:' + color + ';'">
        <span v-if="left !== ''" :style="'background-color:' + color + ';'" class="left">{{ left }}</span>
        <span v-if="right !== '' && right !== null" class="right" :class="{ 'right--only': left === '' }">{{ right }}</span>
    </span>
</template>

<script>
export default {
    name: 'pill-label',
    props: {
        left: {
            type: String,
            default: '',
        },
        right: {
            type: String,
            default: '',
        },
        color: {
            type: String,
            default: '#ff0000',
        },
    },
    created() {},
};
</script>

<style scoped lang="scss">
.pill {
    display: inline-block;
    text-transform: uppercase;
    font-weight: bold;
    font-size: 11px;
    line-height: 1;
    letter-spacing: 1px;
    border: solid 2px;
    border-radius: 10px;
    overflow: hidden;
    margin-right: 5px;

    &--default {
        span {
            color: #1f1f1f !important;
        }
    }

    span {
        padding: 5px 6px 4px;

        &.left {
            display: inline-block;
            color: white;
            padding-right: 4px;

            &:last-child {
                padding-right: 6px;
            }
        }
        &.right {
            display: inline-block;
            font-weight: normal;
            padding-left: 4px;

            &--only {
                padding-left: 6px;
            }
        }
    }
}
</style>
